import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
import imageUrl from "../../../images/StudyCalculatorImg.webp";
const TITLE = "تحويل المعدل التراكمي إلى النظام الأسترالي";
const DESCRIPTION =
  "اكتشف كيفية تحويل معدلك الجامعي إلى النظام الأسترالي بسهولة ودقة. اعرف تفاصيل النظام الأسترالي للدرجات الجامعية.";
const KEYWORDS =
  "النظام الجامعي الأسترالي, تحويل المعدل الجامعي, نظام الدرجات الأسترالي, معدل البكالوريوس, معدل الماجستير, المعدل الجامعي, أستراليا";
const OG_URL = "https://do-calculate.com/calculator/ar/gradetoaustralia";
function GradeToAustralia() {
  const [originalValue, setOriginalValue] = useState("");
  const [convertedValue, setConvertedValue] = useState("");
  const [conversionType, setConversionType] = useState("grade");
  const [showResult, setShowResult] = useState(false);
  const [error, setError] = useState(null);
  const gpaToAustralianGrade = (gpa) => {
    if (gpa >= 4.0) {
      return "HD";
    } else if (gpa >= 3.5 && gpa < 4.0) {
      return "D";
    } else if (gpa >= 3.0 && gpa < 3.5) {
      return "CR";
    } else if (gpa >= 2.5 && gpa < 3.0) {
      return "P";
    } else if (gpa >= 2.0 && gpa < 2.5) {
      return "P-";
    } else {
      return "مدخلات غير صالحة";
    }
  };
  const calculateGrade = (value) => {
    if (conversionType === "grade") {
      const grade = parseFloat(value);
      if (!isNaN(grade) && grade >= 0 && grade <= 100) {
        return (grade / 25).toFixed(2);
      }
    } else if (conversionType === "gpa") {
      const gpa = parseFloat(value);
      if (!isNaN(gpa) && gpa >= 0 && gpa <= 4) {
        return gpaToAustralianGrade(gpa);
      }
    }
    return "مدخلات غير صالحة";
  };
  const handleCalculateClick = () => {
    const converted = calculateGrade(originalValue);
    setConvertedValue(converted);
    setShowResult(true);
    setError(null);
  };
  const handleConversionTypeChange = (newConversionType) => {
    setConversionType(newConversionType);
    setOriginalValue("");
    setConvertedValue("");
    setShowResult(false);
    setError(null);
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  اكتشف كيفية تحويل معدلك الجامعي (مئوي أو تراكمي) إلى النظام
                  الأسترالي بسهولة ودقة. اعرف تفاصيل النظام الأسترالي للدرجات
                  الجامعية باستخدام هذه الأداة المفيدة.
                </p>
              </div>
              <br />
            </div>
            <hr />
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>
                    تحويل المعدل الجامعي إلى النظام الأسترالي
                  </h2>
                </div>
                <hr />
                <div className="form-group">
                  <b>
                    <label>نوع المعدل:</label>
                  </b>
                  <div>
                    <input
                      type="radio"
                      id="gradeConversion"
                      name="conversionType"
                      value="grade"
                      checked={conversionType === "grade"}
                      onChange={() => handleConversionTypeChange("grade")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label
                      htmlFor="gradeConversion"
                      className="form-check-label"
                    >
                      مئوي (100)
                    </label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="gpaConversion"
                      name="conversionType"
                      value="gpa"
                      checked={conversionType === "gpa"}
                      onChange={() => handleConversionTypeChange("gpa")}
                      className="form-check-input"
                      style={{ marginLeft: "4px" }}
                    />
                    <label htmlFor="gpaConversion" className="form-check-label">
                      تراكمي (4.00)
                    </label>
                  </div>
                </div>
                <br />
                <div>
                  <div className="form-group d-flex align-items-center">
                    <b>
                      <label htmlFor="originalValue">
                        {conversionType === "grade"
                          ? "المعدل المئوي:"
                          : "المعدل التراكمي:"}
                      </label>
                    </b>
                    <input
                      type="text"
                      value={originalValue}
                      id="originalValue"
                      onChange={(e) => setOriginalValue(e.target.value)}
                      className="form-control"
                      style={{ width: "200px", marginRight: "4px" }}
                    />
                  </div>
                  <div>
                    <br />
                  </div>
                </div>
                <button
                  className="btn btn-success mt-3"
                  onClick={handleCalculateClick}
                >
                  احسب                </button>
                <br />
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-sm-12 col-md-7">
                {error && (
                  <div className="alert alert-warning">
                    <b>
                      <u>Error:</u>
                    </b>{" "}
                    {error}
                  </div>
                )}
                {showResult &&  (
                  <div
                    style={{ fontSize: "15px" }}
                    className="bg-light bg-gradient text-dark"
                  >
                    <div className="p-3 bg-success bg-gradient text-white">
                      <strong>النتيجة:</strong>
                    </div>
                    <b>
                      {conversionType === "grade"
                        ? `المعدل المئوي بالنسبة للنظام الأسترالي: ${convertedValue}`
                        : `الدرجة الأسترالية بالنسبة للمعدل التراكمي: ${convertedValue}`}
                    </b>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      نظام تصنيف الدرجات الجامعية في أستراليا
                    </h2>
                  </u>
                  <p>
                    في أستراليا، يتم تصنيف الدرجات على مقياس من HD إلى F، حيث HD
                    هو الأفضل وF هو الأسوأ. يمكن تقسيم الدرجات على النحو التالي:
                  </p>
                  <table >
                    <thead>
                      <tr className="bmi-header">
                        <th>المعدل التراكمي (على مقياس 4 نقاط)</th>
                        <th>الدرجة الأسترالية</th>
                        <th>النسبة المئوية المكافئة</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>4.0</td>
                        <td>HD</td>
                        <td>85-100%</td>
                      </tr>
                      <tr>
                        <td>3.5 - 3.9</td>
                        <td>D</td>
                        <td>75-84%</td>
                      </tr>
                      <tr>
                        <td>3.0 - 3.4</td>
                        <td>CR</td>
                        <td>65-74%</td>
                      </tr>
                      <tr>
                        <td>2.5 - 2.9</td>
                        <td>P</td>
                        <td>50-64%</td>
                      </tr>
                      <tr>
                        <td>2.0 - 2.4</td>
                        <td>P-</td>
                        <td>45-49%</td>
                      </tr>
                      <tr>
                        <td>0.0 - 1.9</td>
                        <td>F</td>
                        <td>0-44%</td>
                      </tr>
                    </tbody>
                  </table>
                  <p>
                    هذه المعلومات تساعد في فهم كيفية تحويل المعدلات إلى النظام
                    الأسترالي ومعرفة ما يعادلها بالنسبة المئوية.
                  </p>
                  <b className="text-primary">
                    <span>مثال: </span>
                    إذا كان لديك معدل تراكمي 3.0 على مقياس 4.0، يمكنك تحويله إلى
                    النظام الأسترالي باستخدام الأداة أعلاه وستحصل على النتيجة
                    المعادلة.
                  </b>
                  <p>
                    هذه الأداة مفيدة جدًا للطلاب الدوليين الذين يرغبون في متابعة
                    دراستهم في أستراليا أو التقديم على وظائف تطلب معدل دراسي
                    معين.
                  </p>
                  <div>
                    <p>
                      تعد أستراليا من الدول التي تشهد تطورًا علميًا مستمرًا،
                      وفيها العديد من الجامعات العريقة التي يقصدها الطلاب من
                      جميع أنحاء العالم.
                    </p>
                    <p className="alert alert-info">
                      أن في أستراليا العديد من الجامعات المصنفة عالميًا، ويمتاز
                      النظام الدراسي في الجامعات الأسترالية بالصرامة العلمية
                      والجدة في المناهج. وتعد التكاليف الدراسية في أستراليا
                      معقولة مقارنة ببقية الدول الأوروبية والولايات المتحدة
                      الأميركية.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default GradeToAustralia;
